import {React, useState, useEffect} from "react";
import { Link } from "react-router-dom";
import {storage} from "./firebase.js";
import {ref, getDownloadURL} from "firebase/storage";
import 'firebase/storage';

export function ImageComponent(props) {
    // this function grabs the Image associated with each user's post
    const [imageUrl, setImageUrl] = useState('');
    useEffect(() => {
      // Create a reference to the image in Firebase Storage
      const storageRef = ref(storage, props.picturePath);

      // Download the image and get its URL
        getDownloadURL(storageRef)
        .then((url) => {
        setImageUrl(url);
      });
    }, [props.picturePath]);

    return <img src={imageUrl} alt="User's file uppload" />;
}

function WorkoutCard(props) {
    // this function creates the WorkoutCard from Firebase data
    const { username, picturePath, title, tag1, tag2, description } = props;
    return (
    <section className="featured-workouts">
        {/* links each workout card to their own Article page */}
        <Link
        to="/Article/${username}"
            state = {{
                title: title,
                category: tag1,
                subCategory: tag2,
                content: description,
                username: username,
                picturePath: picturePath,
            }}
        // confirms that the data is being passed to the Article page
        onClick={() => console.log('Data passed to Link component:', {
            title: title,
            category: tag1,
            subCategory: tag2,
            content: description,
            username: username,
            picturePath: picturePath,
            })}
        >
        <div className="cards">
            <div className="card-header">
                <p>{username}</p>
            </div>
            <div className="featured-workouts__img">
            <ImageComponent picturePath = {picturePath}/>
            </div>
            <div className="card-content">
                <h3>{title}</h3>
                <p>Tag 1: {tag1}</p>
                <p>Tag 2: {tag2}</p>
                <p>{description.substring(0,65)}</p>
            </div>
        </div>
        </Link>
    </section>
    )
}

export function WorkoutCardList(props) {
    // This creates an array of all the workout cards
    const componentArray =  props.renderedCardsArray.map((jobObj) => {
        const element = (
        <WorkoutCard
            username={jobObj.username}
            picturePath={jobObj.picturePath}
            title={jobObj.postTitle}
            tag1={jobObj.category}
            tag2={jobObj.subCategory}
            description={jobObj.content}
            key={jobObj.username}
            />
    )
    return element;
})

return (
    <div className="card-container">
        {componentArray}
    </div>
)
}